module.exports = __webpack_public_path__ + "img/65.c45d5d4f.png";